import { createSelector } from '@reduxjs/toolkit';
import selectWishlistPageActions from '@spa/lib/store/wishlists/selectors/selectWishlistPageActions';

const selectFailedDeleteProductFromMyWishlistActionIds = createSelector(
  [selectWishlistPageActions],
  (wishlistsPageActions): ReadonlyArray<number> =>
    wishlistsPageActions.deleteProductFromMyWishlist.failed.map(
      (action): number => action.requestedActionId
    )
);

export default selectFailedDeleteProductFromMyWishlistActionIds;
